module.exports = __webpack_public_path__ + "img/jygl.a64544b9.png";